/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Rename_ShareInputs */

const en_views_rename_share = /** @type {(inputs: Views_Rename_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename and share`)
};

const de_views_rename_share = /** @type {(inputs: Views_Rename_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umbenennen und teilen`)
};

/**
* | output |
* | --- |
* | "Rename and share" |
*
* @param {Views_Rename_ShareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_rename_share = /** @type {((inputs?: Views_Rename_ShareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Rename_ShareInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_rename_share(inputs)
	return en_views_rename_share(inputs)
});